import { Icon } from "@synergy/icons";
import styled from "styled-components";
import { useGlobalFilterContext } from "../../../../contexts/GlobalFilterProvider";
import { MulitpleSelectAtomic } from "../../Atomics/MulitpleSelectAtomic";

const FilterBox = styled.div`
    display: flex;
    background-color: white;
    gap: 20px;
    padding: 5px 20px;
    border-radius: 5px;
    width: auto;
    align-items: center;
`;

export const MapFilterComponent = ({ optionClassesChange, prioritiesDropdown, selectedLayer, prioritiesSelected, optionPriorityChange, optionSeverityChange }) => {
    const { classes, dropdownClasses, severitySelected } = useGlobalFilterContext();

    return (
        <FilterBox>
            <Icon iconsize={'sm'} icon='CollapseOpen' color={'teal-3'} />
            {(selectedLayer === 'Incidents' || selectedLayer === 'Services') ?
                <MulitpleSelectAtomic
                    optionsData={dropdownClasses}
                    handleOptionsChange={(placeholder, selectedClasses) => {
                        if (selectedClasses) {
                            optionClassesChange(selectedClasses);
                        }
                    }}
                    defaultValue={classes}
                    fullWidth={true}
                    placeholder={"Select classes"}
                    allAvailable={true}
                    noTags={true}
                />
                : null}
            {selectedLayer === 'Incidents' && prioritiesDropdown?.length > 0 ?
                <MulitpleSelectAtomic
                    optionsData={prioritiesDropdown}
                    handleOptionsChange={(placeholder, priorities) => {
                        if (priorities) {
                            optionPriorityChange(priorities);
                        }
                    }}
                    defaultValue={prioritiesSelected}
                    fullWidth={true}
                    placeholder={"Select Priorities"}
                    allAvailable={true}
                    noTags={true}
                />
                : null}
        </FilterBox>
    );
};